import { unwrapHubHttpError } from 'academy-common-lib/utils/DataFetchingClient';
import { BROCHURE_URL_BY_LANGUAGE } from '../../constants/AchievementConstants';
import { useGetByIdQuery } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/noauth/TrackPublicChirpService.hooks';
import { useGetPublicAchievementV2Query } from '../../../__generated__/chirp/com/hubspot/credentials/rpc/AchievementPublicRpc.hooks';
import { ACADEMY_SUPPORTED_LANGUAGES } from 'academy-common-lib/constants/academySupportedLanguages';
import { useGetAllAchievementsForUserQuery } from '../../../__generated__/chirp/com/hubspot/credentials/rpc/AchievementRpc.hooks';
import { GET_ALL_ACHIEVEMENTS_FOR_USER_QUERY } from '../../../__generated__/chirp/com/hubspot/credentials/rpc/AchievementRpc.dfc.new';
export { GET_ALL_ACHIEVEMENTS_FOR_USER_QUERY };
export const usePublicAchievement = publicId => {
  var _data$achievement, _data$achievement2;
  const {
    data,
    error,
    loading
  } = useGetPublicAchievementV2Query({
    variables: {
      publicId: publicId
    },
    skip: !publicId,
    fetchPolicy: 'cache-first'
  });
  return {
    publicAchievement: data === null || data === void 0 || (_data$achievement = data.achievement) === null || _data$achievement === void 0 ? void 0 : _data$achievement.achievement,
    publicAchievementUser: data === null || data === void 0 || (_data$achievement2 = data.achievement) === null || _data$achievement2 === void 0 ? void 0 : _data$achievement2.user,
    publicAchievementError: error,
    publicAchievementErrorMessage: data === null || data === void 0 ? void 0 : data.errorMessage,
    publicAchievementLoading: loading
  };
};
export const useAllAchievements = () => {
  const {
    data,
    error: allAchievementsError,
    loading: allAchievementsLoading
  } = useGetAllAchievementsForUserQuery();
  return {
    allAchievements: data === null || data === void 0 ? void 0 : data.achievements,
    allAchievementsError: unwrapHubHttpError(allAchievementsError),
    allAchievementsLoading
  };
};
export const getBrochureRoot = language => BROCHURE_URL_BY_LANGUAGE[language] || BROCHURE_URL_BY_LANGUAGE.en;
const getTrackInfo = (trackInfoByLanguage, language) => {
  const validLanguage = ACADEMY_SUPPORTED_LANGUAGES.find(supported => supported === language);
  if (!validLanguage) return undefined;
  return trackInfoByLanguage[validLanguage];
};
export const useAchievementTrackId = publicId => {
  const {
    publicAchievement
  } = usePublicAchievement(publicId);
  if (!publicAchievement) return undefined;
  const trackInfo = getTrackInfo(publicAchievement.courseInfoByLanguage, publicAchievement.language);
  return trackInfo === null || trackInfo === void 0 ? void 0 : trackInfo.courseId;
};
export const useAchievementLessons = publicId => {
  var _trackInfo$lessons;
  const {
    publicAchievement
  } = usePublicAchievement(publicId);
  if (!publicAchievement) return null;
  const trackInfo = getTrackInfo(publicAchievement.courseInfoByLanguage, publicAchievement.language);
  return (_trackInfo$lessons = trackInfo === null || trackInfo === void 0 ? void 0 : trackInfo.lessons) !== null && _trackInfo$lessons !== void 0 ? _trackInfo$lessons : null;
};
export const useAchievementUser = publicId => {
  const {
    publicAchievement,
    publicAchievementUser
  } = usePublicAchievement(publicId);
  if (!publicAchievement || !publicAchievementUser) return null;
  return Object.assign({
    userId: publicAchievement.userId
  }, publicAchievementUser);
};
export const useAchievementCertificateUrl = publicId => {
  var _publicAchievement$ce;
  const {
    publicAchievement
  } = usePublicAchievement(publicId);
  if (!publicAchievement) return null;
  return (_publicAchievement$ce = publicAchievement.certificate) !== null && _publicAchievement$ce !== void 0 ? _publicAchievement$ce : null;
};
export const useAchievementImageUrl = publicId => {
  var _publicAchievement$ce2;
  const {
    publicAchievement
  } = usePublicAchievement(publicId);
  if (!publicAchievement) return null;
  if (publicAchievement.credentialType === 'BADGE') {
    var _ref, _publicAchievement$ic;
    return (_ref = (_publicAchievement$ic = publicAchievement.icon) !== null && _publicAchievement$ic !== void 0 ? _publicAchievement$ic : publicAchievement.badge) !== null && _ref !== void 0 ? _ref : null;
  }
  return (_publicAchievement$ce2 = publicAchievement.certificate) !== null && _publicAchievement$ce2 !== void 0 ? _publicAchievement$ce2 : null;
};
export function getMetadataLanguageFallback(metadata, targetLanguage) {
  return metadata[targetLanguage] ? metadata[targetLanguage] : metadata[Object.keys(metadata)[0]];
}
export const useTrackPublicData = trackId => {
  const {
    data,
    loading,
    error
  } = useGetByIdQuery({
    variables: {
      trackId: trackId
    },
    skip: !trackId
  });
  return {
    track: data === null || data === void 0 ? void 0 : data.track,
    trackLoading: loading,
    trackError: error
  };
};